import { ItemTypes } from '../../constants/constants';
import { proposalTableDesign } from '../../shared/tables/proposalTableStyle';
import { boxPropsFromStyle } from '../../shared/boxes/styleTemplate';
import { themeStyleById, themeStylesOf } from '../../shared/theme/themeStyles';
import { THEMED_BLOCKS } from '../puck/themedBlocks';
import { puckContentConfig } from '../puck/puckContentConfig';
import {
  SAMPLE_TEXT, block, samplePropsOf, styledElementBlock,
} from './elementSamples';

export { SAMPLE_TEXT, block };

const styleOf = (styles, id) => (styles || []).find((style) => style.id === id) || styles?.[0];


/**
 * Le bloc du site d'un élément (tableau, volet, carte info) rendu avec un de
 * ses styles de `configuration` (ou le premier), garni d'un contenu d'exemple.
 */
export function elementBlocks(values, configuration) {
  switch (values.elementType || ItemTypes.TABLE) {
    case ItemTypes.TABLE: {
      const id = values.tableStyleId ?? configuration.tableStyles?.[0]?.id;
      return [styledElementBlock('table', proposalTableDesign(id, configuration), puckContentConfig.components)];
    }
    case ItemTypes.ACCORDION_PANEL: {
      const style = styleOf(configuration.accordionPanelStyles, values.accordionPanelStyleId);
      return [block('AccordionPanel', { ...samplePropsOf('accordion', puckContentConfig.components), ...boxPropsFromStyle(style) })];
    }
    case ItemTypes.INFO_CARD: {
      const { sample, ...style } = boxPropsFromStyle(
        styleOf(configuration.infoCardStyles, values.infoCardStyleId),
      );
      return [block('InfoCard', {
        ...samplePropsOf('infoCard', puckContentConfig.components),
        ...style,
        ...(sample?.value ? { value: sample.value } : {}),
        ...(sample?.description ? { description: sample.description } : {}),
      })];
    }
    default:
      return null;
  }
}

const ELEMENT_OF_KIND = {
  table: { elementType: ItemTypes.TABLE, idKey: 'tableStyleId' },
  infoCard: { elementType: ItemTypes.INFO_CARD, idKey: 'infoCardStyleId' },
  accordion: { elementType: ItemTypes.ACCORDION_PANEL, idKey: 'accordionPanelStyleId' },
};

/** Un titre du niveau donné. */
export const titleBlocks = (level) => [
  block('ProposalRichText', { html: `<h${level}>Titre de niveau ${level}</h${level}>` }),
];

/** Du texte courant, rien d'autre : ce que règle la police du site. */
export const textBlocks = () => [
  block('ProposalRichText', { html: `<p>${SAMPLE_TEXT}</p><p>${SAMPLE_TEXT}</p><p>${SAMPLE_TEXT}</p>` }),
];

/**
 * Un composant du thème rendu avec un de ses styles : les éléments d'un
 * document avec leur contenu d'exemple, les composants du site avec celui de
 * leurs valeurs par défaut (libellé, slides, étapes…).
 */
export function themeElementBlocks(kind, styleId, configuration) {
  const element = ELEMENT_OF_KIND[kind];
  if (element) {
    return elementBlocks({ elementType: element.elementType, [element.idKey]: styleId }, configuration);
  }
  const style = themeStyleById(themeStylesOf(configuration, kind), styleId);
  return [styledElementBlock(kind, style ? THEMED_BLOCKS[kind].valuesOf(style, configuration) : {}, puckContentConfig.components)];
}
